import React, { Fragment } from 'react';
import Img from '../../../../../../components/Img';
import './WidgetPreviewBannerScrollLayout.scss';

const WidgetPreviewBannerScrollLayout = (props) => {
  const { list } = props;

  return (
    <div className="widget-banner-scroll-layout">
      {list.map((eventSection, index) => (
        <div key={index} className="widget-banner-section">
          <Img clickAble={false} src={eventSection.url} />

          {eventSection.isUsedTitle ? (
            <Fragment>
              <div className="title">
                {eventSection.title ? (
                  eventSection.title
                ) : (
                  <span className="require-info">배너 섹션 타이틀을 설정해주세요.</span>
                )}
              </div>

              {eventSection.contents ? <div className="contents">{eventSection.contents}</div> : null}
            </Fragment>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default WidgetPreviewBannerScrollLayout;
